import { render } from "./DealBody.vue?vue&type=template&id=56233cc4&scoped=true"
import script from "./DealBody.vue?vue&type=script&lang=js"
export * from "./DealBody.vue?vue&type=script&lang=js"

import "./DealBody.vue?vue&type=style&index=0&id=56233cc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56233cc4"]])

export default __exports__